<router-outlet></router-outlet>
<og-ai-chatbot></og-ai-chatbot>
